import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ResponsiveService } from '@services/responsive';
import { defaultBreadcrumbConfig } from '@shared/components/breadcrumb/config';
import { BreadcrumbService } from '@shared/components/breadcrumb/services';
import { Color } from '@shared/enums';
import { ColorClassPipe, TruncatePipe } from '@shared/pipes';

@Component({
  selector: 'app-breadcrumb',
  styleUrl: './breadcrumb.component.scss',
  templateUrl: './breadcrumb.component.html',
  imports: [RouterLink, ColorClassPipe, TruncatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbComponent {
  readonly color = input<keyof typeof Color>(defaultBreadcrumbConfig.color);
  breadcrumb = inject(BreadcrumbService).breadcrumb;
  breakpoints = inject(ResponsiveService).breakpoints;
}
